import React from 'react';

import cn from '~/Utils/cn';

export const CategoriesColors = {
  'berry-600': 'berry-600',
  'berry-700': 'berry-700',
  'blue-600': 'blue-600',
  'blueSky-700': 'blueSky-700',
  'grey-600': 'grey-600',
  'orange-700': 'orange-700',
  'pink-600': 'pink-600',
  'purple-600': 'purple-600',
  'purple-700': 'purple-700',
  'teal-600': 'teal-600',
  'yellow-800': 'yellow-800',
};

export const colorsToBgMap: { [K in keyof typeof CategoriesColors]: string } = {
  'berry-600': 'bg-berry-600',
  'berry-700': 'bg-berry-700',
  'blue-600': 'bg-blue-600',
  'blueSky-700': 'bg-blueSky-700',
  'grey-600': 'bg-grey-600',
  'orange-700': 'bg-orange-700',
  'pink-600': 'bg-pink-600',
  'purple-600': 'bg-purple-600',
  'purple-700': 'bg-purple-700',
  'teal-600': 'bg-teal-600',
  'yellow-800': 'bg-yellow-800',
};

const sizeToClassNamesMap = {
  XS: 'h-8 w-8',
  M: 'h-16 w-16',
} as const;

interface ColoredDotProps {
  color: keyof typeof CategoriesColors;
  size?: keyof typeof sizeToClassNamesMap;
}

const ColoredDot: React.FC<ColoredDotProps> = ({ color, size = 'M' }) => {
  return (
    <div
      className={cn(sizeToClassNamesMap[size], 'rounded-full', {
        [colorsToBgMap[color]]: colorsToBgMap[color],
      })}
    />
  );
};

export default ColoredDot;
